import { Link } from './link';

export class OtherLinks {
    public otherLinks: Link[] = [];
}
